export default {
      id: "delivery_yandex-usage",
      viewBox: "0 0 88 18",
      url: __webpack_public_path__ + "sprite.svg#delivery_yandex",
      toString: function () {
        return this.url;
      }
    }